<template>
    <div class="box">
        <div class="container">
            <headerWX class="headerWX"></headerWX>
            <img class="bg" src="@/assets/imgs/DoubleEleven/bg.png" alt="">
            <div class="container_body">
                <div class="task">
                    <div class="taskList">
                        <!-- 每日任务 -->
                        <div class="dailyMission taskList_item">
                            <img src="@/assets/imgs/DoubleEleven/dailyMission.png" alt="">
                            <div class="dailyMission_item">
                                <div class="taskList_list" v-for="value in ActivityInfo.dailyTasks" :key="value.taskId">
                                    <div class="text">{{ value.taskDesc }}</div>
                                    <div class="award">
                                        <div class="award_item">
                                            {{ value.rewardItemName }}X{{ value.rewardNum }}
                                        </div>
                                        <div class="btn">
                                            <img v-if="value.taskUrl && value.isCompleted == false"
                                                src="@/assets/imgs/DoubleEleven/goToAccomplish.png" @click="go(value)">
                                            <img v-else-if="value.isCompleted == true && value.isClaimed == false"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png" @click="receive(value)"
                                                alt="">
                                            <img v-else-if="value.isClaimed == true"
                                                src="@/assets/imgs/DoubleEleven/OverGet_btn.png" alt="">
                                            <img v-else style="filter: grayscale(100%);"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- VIP福利 -->
                        <div class="VIPBenefits taskList_item">
                            <img src="@/assets/imgs/DoubleEleven/VIPBenefits.png" alt="">
                            <div class="VIPBenefits_item">
                                <div class="VIPBenefits_list">
                                    <div class="text">VIP等级达到LV5及以上</div>
                                    <div class="award">
                                        <div class="award_item">
                                            助力券X10
                                        </div>
                                        <div class="btn">
                                            <img v-if="ActivityInfo.vipBonusStatus == 0"
                                                style="filter: grayscale(100%);"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png" alt="">
                                            <img v-else-if="ActivityInfo.vipBonusStatus == 1"
                                                src="@/assets/imgs/DoubleEleven/get_btn.png" @click="getVip(value)">
                                            <img v-else-if="ActivityInfo.vipBonusStatus == 2"
                                                src="@/assets/imgs/DoubleEleven/OverGet_btn.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 助力券 -->
                        <div class="ticket taskList_item">
                            <img src="@/assets/imgs/DoubleEleven/ticket.png" alt="">
                            <div class="ticket_item">
                                <div class="ticket_num">{{ ActivityInfo.supportTickets }}</div>
                                <div class="ticket_num">{{ ActivityInfo.supportTicketsTotalUsed }}</div>
                                <div class="ticket_num">{{ ActivityInfo.supportTicketsTotalEarned }}</div>
                            </div>
                        </div>
                        <!-- 工会投票 -->
                        <div class="laborUnion">
                            <div class="laborUnion_item" v-for="value in ActivityInfo.guildList" :key="value.guildId">
                                <img src="@/assets/imgs/DoubleEleven/laborUnion.png" alt=""></img>
                                <div class="laborUnion_list">
                                    <p class="name">{{ value.serverName }}</p>
                                    <div class="headPortrait_img">
                                        <img :src="value.guildIcon" alt="">
                                    </div>
                                    <p class="area">{{ value.guildName }}</p>
                                    <div class="btn">
                                        <img @click="Help(value, 1)" src="@/assets/imgs/DoubleEleven/help_noeBtn.png"
                                            alt="">
                                        <img @click="Help(value, 10)" src="@/assets/imgs/DoubleEleven/help_tenBtn.png"
                                            alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="taskRight">
                        <!-- 工会排行榜 -->
                        <div class="UnionRankingList RankingList">
                            <img src="@/assets/imgs/DoubleEleven/UnionRankingList.png" alt="">
                            <div class="RankingList_body">
                                <div class="Ranking_item" v-for="value in GuildRankList" :key="value.guildId">
                                    <div class="text ranking">{{ value.rank }}</div>
                                    <div class="text username">{{ value.serverName }}</div>
                                    <div class="text area">{{ value.guildName }}</div>
                                    <div class="text num">{{ value.totalVotes }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- 个人排行榜 -->
                        <div class="PersonalRankingList RankingList">
                            <img src="@/assets/imgs/DoubleEleven/PersonalRankingList.png" alt="">
                            <div class="RankingList_body">
                                <div class="Ranking_item" v-for="value in PersonalContributionRank" :key="value.rank">
                                    <div class="text ranking">{{ value.rank }}</div>
                                    <div class="text username">{{ value.roleName }}</div>
                                    <div class="text area">{{ value.serverName }}</div>
                                    <div class="text num">{{ value.totalVote }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 热力情况 -->
                <div class="HotTicket">
                    <img src="@/assets/imgs/DoubleEleven/HotTicket_tit.png" alt="">
                    <div class="HotTicket_body">
                        <img src="@/assets/imgs/DoubleEleven/HotTicket_bg.png" alt="">
                        <div class="HotTicket_it">
                            <div class="HotTicket_num">{{ ActivityInfo.heatValue }}</div>
                            <div class="HotTicket_num">{{ ActivityInfo.heatValueTotalUsed }}</div>
                            <div class="HotTicket_num">{{ ActivityInfo.heatValueTotalEarned }}</div>
                        </div>
                    </div>
                    <!-- 商店 -->
                    <div class="shop_body">
                        <div class="shop_item" v-for="value in ActivityInfo.heatShopItems" :key="value.itemId">
                            <div class="shop_item_item">
                                <img src="@/assets/imgs/DoubleEleven/shop_item.png" alt="">
                                <div class="shop_content">
                                    <div class="price">X {{ value.price }}</div>
                                    <div class="img">
                                        <el-tooltip :content="value.itemDesc" placement="top" effect="light">
                                            <img :src="value.itemImg" alt="">
                                        </el-tooltip>

                                    </div>
                                    <div class="name">{{ value.itemName }}</div>
                                </div>
                            </div>
                            <div class="shop_item_btn">
                                <img v-if="value.status == 0" style="filter: grayscale(100%);"
                                    src="@/assets/imgs/DoubleEleven/exchange_btn.png">
                                <img v-else-if="value.status == 1" @click="go_shop(value)"
                                    src="@/assets/imgs/DoubleEleven/exchange_btn.png" alt="">
                                <img v-else-if="value.status == 2"
                                    src="@/assets/imgs/DoubleEleven/OverExchange_btn.png">
                            </div>
                            <p class="limitCount" v-if="value.limitCount !== 0">({{ value.buyCount }}/ {{
                                value.limitCount }})</p>
                        </div>
                    </div>
                </div>
                <div class="explain">
                    <img src="@/assets/imgs/DoubleEleven/explain_bg.png" alt="">
                    <div class="explain_body">
                        <img src="@/assets/imgs/DoubleEleven/explain_tit.png" alt="">
                        <div class="explain_Content">
                            <p>1.您每次助力将消耗一张助力券，助力成功后可获的10点热力。前往热力商店使用热力可兑换心仪奖励。</p>
                            <p>2.活动结束时排名第一的家族族长将可以活动专属称号—富甲天下以及自选36星技能卡一张。</p>
                            <p>3.活动期间为获胜家族累计助力大于等于200次的玩家将获得家族黄金宝箱一个。</p>
                            <p>4.活动期间累计助力大于等于30次的玩家活动结束后可获得2025年新宠福袋第二期。</p>
                            <p>5.活动期间累计为家族助力最多且唯一的玩家将获得愿望清单一张。</p>
                            <p>温馨提示：</p>
                            <p style="text-indent: 2rem;">1）家族黄金宝箱中包含活动专属基因宠物一只。</p>
                            <p style="text-indent: 2rem;">2）活动结果以及活动专属基因宠物天性请留意官网后续公告。</p>
                            <p style="text-indent: 2rem;">3）活动奖励为拾取绑定。</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- 蒙版 -->
        <div class="masking" v-if="dialog">
            <div class="maskContent">
                <img class="mask_bg" src="@/assets/imgs/DoubleEleven/masking_bg.png" alt="">
                <div class="close_brn" @click="dialog = false"></div>
                <div class="body">
                    <div class="help" v-if="dialog_type == 'help'">
                        <div class="tit">温馨提示</div>
                        <div class="help_tit">助力成功将消耗 <span>{{ dialog_item.Times }}张</span> 助力券并获得<span>
                                {{ dialog_item.Times * 10 }}点热力</span> </div>
                        <div class="possess_tit">您当前拥有<span>{{ ActivityInfo.supportTickets }}</span>张助力券</div>
                        <div class="possess_tit">当前助力的工会是<span>{{ dialog_item.serverName }}</span></div>
                        <div class="btn">
                            <img @click="goHele" src="@/assets/imgs/DoubleEleven/confirm_btn.png" alt="">
                            <img @click="dialog = false" src="@/assets/imgs/DoubleEleven/cancel_btn.png" alt="">
                        </div>
                    </div>
                    <div class="shop" v-if="dialog_type == 'shop'">
                        <div class="type_img">
                            <img :src="dialog_item.itemImg" alt="">
                        </div>
                        <div class="shop_tit">您确认要兑换"<span>{{ dialog_item.itemName }}</span> "吗</div>
                        <div class="tit">本次兑换操作不可逆</div>
                        <div class="btn">
                            <img @click="goShop" src="@/assets/imgs/DoubleEleven/confirm_btn.png" alt="">
                            <img @click="dialog = false" src="@/assets/imgs/DoubleEleven/cancel_btn.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import Cookies from 'js-cookie'
import {
    getPersonalContributionRankApi,
    getGuildRankListApi,
    getActivityInfoApi,
    claimDailyTaskRewardApi,
    claimVipBonusApi,
    voteApi,
    buyHeatShopItemApi
} from '@/api/DoubleEleven'
export default {
    components: {
        headerWX,
    },
    data() {
        return {
            dialog: false,
            dialog_type: '', //弹窗类型
            dialog_item: {}, // 弹窗数据

            ActivityInfo: [], // 活动数据
            GuildRankList: [], // 工会信息
            PersonalContributionRank: [],  //个人工会排行
        }
    },
    created() {
        // this.openPageScroll()
        // 下一帧（DOM 更新完后）再滚动
        this.$nextTick(() => {
            this.scrollToTop()
        })
    },
    mounted() {
        this.init()
    },
    methods: {



        //打开购买商品弹窗
        go_shop(item) {
            this.dialog_item = item
            this.dialog_type = 'shop'
            this.dialog = true

        },
        //购买商品
        async goShop() {
            await buyHeatShopItemApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
                itemId: this.dialog_item.itemId,
                buyNum: 1,
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.dialog_item = {}
                    this.dialog_type = ''
                    this.dialog = false
                    this.init()
                } else {
                    this.$message.error(data.message)
                }
            })
        },
        // 打开工会助力弹窗
        Help(item, Times) {
            item.Times = Times

            this.dialog_item = item
            this.dialog_type = 'help'
            this.dialog = true
            console.log(item);

        },
        //工会助力
        async goHele() {
            if (this.ActivityInfo.supportTickets <= 0 || this.ActivityInfo.supportTickets < this.dialog_item.Times) {
                this.$message.info('加油券不足,请先去获取加油券吧!')
            } else {
                await voteApi({
                    activityName: '2025_guild_vote_activity',
                    userId: Cookies.get('cwsl_userId'),
                    guildId: this.dialog_item.guildId,
                    voteNum: this.dialog_item.Times
                }).then(({ data }) => {
                    if (data.state == 200) {
                        this.$message.success(data.data.message)
                        this.dialog_item = {}
                        this.dialog_type = ''
                        this.dialog = false
                        this.init()
                    } else {
                        this.$message.error(data.data.message)
                    }
                })
            }
        },

        // 去完成
        go(item) {
            if (item.taskUrl.indexOf("http") != -1) {
                window.open(item.taskUrl, "_blank");
            } else {
                this.$router.push({
                    path: item.taskUrl,
                });
            }
        },
        // 任务领取
        async receive(item) {
            await claimDailyTaskRewardApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
                taskId: item.taskId
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.init()
                } else {
                    this.$message.error(data.data.message)
                }
            })
        },
        // Vip领取
        async getVip() {
            await claimVipBonusApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
                // taskId: item.taskId
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.data.message)
                    this.init()
                } else {
                    this.$message.error(data.data.message)
                }
            })
        },

        //初始化
        async init() {
            //个人工会排行
            await getPersonalContributionRankApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            })
                .then(({ data }) => {
                    if (data.state == 200) {
                        this.PersonalContributionRank = data.data.rankList
                    }
                })

            // 工会信息
            await getGuildRankListApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.GuildRankList = data.data.rankList
                }
            })

            // 活动数据
            await getActivityInfoApi({
                activityName: '2025_guild_vote_activity',
                userId: Cookies.get('cwsl_userId'),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.ActivityInfo = data.data
                }
            })
        },

        scrollToTop() {
            // 确保容器存在
            if (this.$refs.scrollContainer) {
                this.$refs.scrollContainer.scrollTop = 0;
            }
            // 同时让整个页面也滚动到顶部（防止有 window 滚动）
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        },
    }
}


</script>
<style lang="less">
#app {
    background: linear-gradient(to bottom, #a8000d, #f48b4f, #9e0007);
}
</style>
<style lang="less" scoped>
.container {
    background-image: url(../../assets/imgs/DoubleEleven/bg.png);

    // background: linear-gradient(to right, rgb(237, 33, 58), rgb(147, 41, 30));
    min-width: 1200px;
    max-width: 2000px;
    margin: auto;
    position: relative;
    padding-bottom: 300px;
    overflow: hidden;

    .headerWX {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
    }

    .bg {
        width: 100%;
        position: absolute;
    }

    .container_body {
        position: relative;
        // top: 180px;
        width: 70%;
        left: 50%;
        transform: translateX(-50%);

        // 每日任务 排行榜
        .task {
            display: flex;

            //左侧
            .taskList {
                width: 65%;
                height: 100%;

                // 公用
                .taskList_item {
                    text-align: center;
                    margin-bottom: 20px;
                    position: relative;

                    img {
                        max-width: 100%;
                    }
                }

                //每日任务
                .dailyMission {
                    .dailyMission_item {
                        position: absolute;
                        top: 34%;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 80%;
                        min-width: 500px;
                        height: 52%;
                        display: flex;
                        flex-direction: column;

                        .taskList_list {
                            height: 50%;
                            display: flex;

                            .text {
                                width: 51%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #CA4B2B;
                                font-size: 20px;
                                font-weight: 600;
                            }

                            .award {
                                width: 49%;
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;
                                gap: 10%;

                                .award_item {
                                    color: #CA4B2B;
                                    font-size: 20px;
                                    font-weight: 600;
                                }


                                .btn {
                                    width: 30%;

                                    img {
                                        width: 100%;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }

                // vip福利
                .VIPBenefits {
                    .VIPBenefits_item {
                        position: absolute;
                        top: 42%;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 80%;
                        min-width: 500px;
                        height: 40%;
                        // background: rgba(49, 175, 114, 0.644);
                        display: flex;
                        flex-direction: column;

                        .VIPBenefits_list {
                            height: 100%;
                            display: flex;

                            .text {
                                width: 51%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #CA4B2B;
                                font-size: 20px;
                                font-weight: 600;
                            }

                            .award {
                                width: 49%;
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;
                                gap: 10%;

                                .award_item {
                                    color: #CA4B2B;
                                    font-size: 20px;
                                    font-weight: 600;
                                }

                                .btn {
                                    width: 30%;

                                    img {
                                        width: 100%;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }

                //助力券
                .ticket {
                    .ticket_item {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 95%;
                        min-width: 500px;
                        max-width: 760px;
                        height: 34%;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;

                        .ticket_num {
                            font-weight: 600;
                            font-size: 20px;
                            color: #CA4B2B;
                        }
                    }

                }

                // 工会投票
                .laborUnion {
                    width: 100%;
                    display: flex;
                    justify-content: space-evenly;

                    >div {
                        flex: 1;
                        text-align: center;
                        position: relative;

                        >img {
                            width: 100%;
                        }
                    }

                    .laborUnion_list {
                        position: absolute;
                        top: 10%;
                        height: 78%;
                        width: 80%;
                        left: 50%;
                        transform: translateX(-50%);

                        .name {
                            font-weight: 600;
                            font-size: 20px;
                            color: #CA4B2B;
                            padding: 8% 0;
                            text-align: center;
                        }

                        .headPortrait_img {
                            width: 100%;
                            overflow: hidden;

                            >img {
                                border-radius: 50%;
                                width: 50%;
                                aspect-ratio: 1/1;

                            }
                        }

                        .area {
                            font-weight: 600;
                            font-size: 20px;
                            color: #CA4B2B;
                            padding: 8% 0;
                            text-align: center;
                        }

                        .btn {
                            width: 100%;
                            display: flex;
                            width: 100%;
                            justify-content: space-around;
                            align-items: center;

                            >img {
                                // max-width: 80%;
                                width: 40%;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }


            // 右侧
            .taskRight {
                width: 35%;
                height: 100%;

                //公用
                .RankingList {
                    max-width: 100%;
                    position: relative;

                    >img {
                        width: 100%;
                    }
                }

                // 工会排行榜
                .UnionRankingList {}

                // 个人排行榜
                .PersonalRankingList {}

                .RankingList_body {
                    position: absolute;
                    top: 13.5%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 89%;
                    height: 82%;

                    .Ranking_item {
                        display: flex;
                        align-items: center;
                        height: 10%;

                        .text {
                            text-align: center;
                            white-space: nowrap;
                            /* 禁止换行 */
                            overflow: hidden;
                            /* 隐藏溢出内容 */
                            text-overflow: ellipsis;
                            /* 显示省略号 */
                            font-weight: 600;
                        }

                        .ranking {
                            width: 20%;
                        }

                        .username {
                            width: 33%;
                        }

                        .area {
                            width: 23%;
                        }

                        .num {
                            width: 24%;
                        }
                    }
                }
            }
        }

        // 热力情况
        .HotTicket {
            margin-top: 80px;
            text-align: center;

            .HotTicket_body {
                margin-bottom: 50px;
                position: relative;

                >img {
                    max-width: 100%;
                }

                .HotTicket_it {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 87%;
                    height: 35%;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;

                    .HotTicket_num {
                        font-weight: 600;
                        font-size: 20px;
                        color: #CA4B2B;
                    }
                }
            }

            //商店
            .shop_body {
                display: flex;
                flex-wrap: wrap;

                .shop_item {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    margin-bottom: 20px;

                    .shop_item_item {
                        width: 200px;
                        max-width: 100%;
                        margin-bottom: 10px;
                        position: relative;

                        >img {
                            max-width: 100%;
                        }

                        .shop_content {
                            position: absolute;
                            top: 10%;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 80%;
                            height: 80%;
                            // background-color: #2bca8875;

                            .price {
                                // width: 100%;
                                height: 25%;
                                display: flex;
                                align-items: center;
                                padding-left: 43%;
                                font-weight: 600;
                                font-size: 20px;
                                color: #ffffff;
                                text-shadow: 1px 1px 0 #CA4B2B, -1px -1px 0 #CA4B2B, 1px -1px 0 #CA4B2B, -1px 1px 0 #CA4B2B;
                            }

                            .img {
                                height: 51%;
                                display: flex;
                                justify-content: center;
                                align-items: center;

                                >img {
                                    max-width: 100%;
                                    max-height: 100%;
                                }
                            }

                            .name {
                                height: 25%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: 600;
                                color: #ffffff;
                                text-shadow: 1px 1px 0 #CA4B2B, -1px -1px 0 #CA4B2B, 1px -1px 0 #CA4B2B, -1px 1px 0 #CA4B2B;
                            }
                        }
                    }

                    .shop_item_btn {
                        width: 100%;

                        >img {
                            max-width: 80%;
                            cursor: pointer;
                        }
                    }

                    .limitCount {
                        color: #ffffff;
                        text-shadow: 1px 1px 0 #CA4B2B, -1px -1px 0 #CA4B2B, 1px -1px 0 #CA4B2B, -1px 1px 0 #CA4B2B;
                    }
                }
            }
        }

        // 说明
        .explain {
            width: 100%;
            position: relative;
            text-align: center;

            >img {
                max-width: 100%;
            }

            .explain_body {
                position: absolute;
                top: 13%;
                left: 50%;
                transform: translateX(-50%);
                width: 80%;
                height: 75%;

                // background-color: #ca4b2b56;
                .explain_Content {
                    width: 100%;
                    height: 90%;
                    // background-color: #CA4B2B;

                    p {
                        text-align: left;
                        padding: 4px 0;
                        font-size: 20px;
                    }
                }
            }
        }
    }

    .container_body::before {
        height: 180px;
        width: 1px;
        content: "";
        /* 伪元素必须有 content */
        display: block;
        /* 作为块级元素撑开高度 */
    }



}

.masking {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, 0.575);
    z-index: 1000;

    .maskContent {
        min-width: 600px;
        max-width: 1200px;
        width: 70vw;
        margin: auto;
        position: relative;
        top: 15%;
        overflow: hidden;
        // background-color: #CA4B2B;
        text-align: center;

        .mask_bg {
            max-width: 80%;
        }

        .close_brn {
            position: absolute;
            top: 14%;
            right: 18.2%;
            width: 4%;
            height: 9%;
            cursor: pointer;
        }

        .body {
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            height: 65%;
            // background-color: #30ca2b83;

            .help {
                width: 100%;
                height: 100%;

                .tit {
                    font-size: 20px;
                    margin: 2%;
                    font-weight: 600;
                    color: #CA4B2B;
                }

                .help_tit {
                    font-size: 20px;
                    margin: 5%;

                    >span {
                        color: red;
                        font-size: 25px;

                    }
                }

                .possess_tit {
                    font-size: 20px;
                    margin: 5%;

                    >span {
                        color: red;
                        font-size: 25px;

                    }
                }

                .btn {
                    width: 100%;
                    max-height: 20%;
                    position: absolute;
                    bottom: 3%;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;

                    >img {
                        max-width: 30%;
                        cursor: pointer;
                    }
                }
            }

            .shop {
                width: 100%;
                height: 100%;

                .type_img {
                    width: 100%;
                    height: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    >img {
                        height: 100%;
                    }
                }

                .shop_tit {
                    font-size: 20px;
                    margin: 2%;

                    >span {
                        color: red;
                        font-size: 25px;

                    }
                }

                .tit {
                    font-size: 1.5rem;
                }

                .btn {
                    width: 100%;
                    max-height: 20%;
                    position: absolute;
                    bottom: 3%;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;

                    >img {
                        max-width: 30%;
                        cursor: pointer;
                    }
                }
            }
        }
    }

}
</style>